type VoiceSearchResult = {
    voice: SpeechSynthesisVoice | undefined,
    foundAnyVoices: boolean,
}


export class Util {
    public static playSound(utterance: string, showError: {(): void}, playSound: boolean=true) {
        if(!playSound) {
            return;
        }

        const msg = new SpeechSynthesisUtterance();
        msg.text = utterance;
        msg.rate = 1;
        msg.pitch = 1;

        this.getVoiceAndSpeak(msg, showError)
    }

    private static getVoiceAndSpeak(msg: SpeechSynthesisUtterance, showError: {(): void}) {
        let voiceSearchResult = this.getVoice();
        if(voiceSearchResult.voice) {
            msg.voice = voiceSearchResult.voice;
            speechSynthesis.speak(msg);
        } else if(!voiceSearchResult.foundAnyVoices) {
            speechSynthesis.onvoiceschanged = (() => {this.getVoiceAndSpeak(msg, showError)})
        } else {
            showError();
        }
    }

    private static getVoice(): VoiceSearchResult{
        let voices = window.speechSynthesis.getVoices();
        let voice = voices.find((voice) => {
            return voice.lang == "ja-JP"
        });
        return {
            voice: voice,
            foundAnyVoices: voices.length > 0,
        };
    }
}


// WEBPACK FOOTER //
// ./src/Util.ts